export default __webpack_public_path__ + "static/media/left_arr.46f9b388.svg";